import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { UnsubscribeService } from '@core/services/unsubscribe.service';
import { filter, map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'gcc-text-input',
  template: `
    <input
      [formControl]="formControl"
      class="form-control"
      type="text"
      [placeholder]="placeholder"
      [attr.id]="id"
      [attr.name]="name"
      [attr.maxlength]="maxLength"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true
    },
    UnsubscribeService
  ]
})
export class TextInputComponent implements ControlValueAccessor {
  @Input() public placeholder: string;
  @Input() public id: string;
  @Input() public name: string;
  @Input() public maxLength: number;

  public formControl = new FormControl();

  constructor(private unsubscribe$: UnsubscribeService) {
    this.formControl.valueChanges
      .pipe(
        map(value => value?.trim()),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(value => this.onChange(value));
  }

  public onChange: (value: string) => string = v => v;
  public onTouch: (value: string) => string = v => v;

  public registerOnTouched(fn: (value: string) => string): void {
    this.onTouch = fn;
  }

  public registerOnChange(fn: (value: string) => string): void {
    this.onChange = fn;
  }

  public writeValue(value: string): void {
    this.formControl.setValue(value || '', { emitEvent: false });
  }

  public setDisabledState(isDisabled: boolean): void {
    // For avoiding error ExpressionChangedAfterItHasBeenCheckedError postpone operation to microtask  after form initialization
    Promise.resolve().then(() => (isDisabled ? this.formControl.disable() : this.formControl.enable()));
  }
}
